import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_spinner_animated } from '@fiverr-private/icons';

import classes from './styles.module.scss';

const Loader = ({ className }) => (
    <div className={`${classes.loader} ${className}`}>
        <Icon size={40}>{r_spinner_animated}</Icon>
    </div>
);

Loader.propTypes = {
    className: PropTypes.bool,
};

export default Loader;
